// extracted by mini-css-extract-plugin
module.exports = {"moreWrp":"moreOptions_moreWrp__jKidS","optionWrp":"moreOptions_optionWrp__1B11p","opt":"moreOptions_opt__uIYWl","danger":"moreOptions_danger__1N2r1"};